module.exports={
  "modules": {
    "dispatcherDel": {
      "require": "./lib/dispatcher/dispatcher-del",
      "type": "value"
    },
    "dispatcherGet": {
      "require": "./lib/dispatcher/dispatcher-get",
      "type": "value"
    },
    "dispatcherGetAll": {
      "require": "./lib/dispatcher/dispatcher-get-all",
      "type": "value"
    },
    "dispatcherGetCached": {
      "require": "./lib/dispatcher/dispatcher-get-cached",
      "type": "value"
    },
    "dispatcherGetList": {
      "require": "./lib/dispatcher/dispatcher-get-list",
      "type": "value"
    },
    "dispatcherWriteOp": {
      "require": "./lib/dispatcher/dispatcher-write-op",
      "type": "value"
    },
    "fieldRequests": {
      "require": "./web/field-requests",
      "type": "value"
    },
    "fieldStreams": {
      "require": "./web/field-streams",
      "type": "value"
    },
    "httpFuture": {
      "require": "./lib/http-future",
      "type": "value"
    },
    "loginRequests": {
      "require": "./lib/login-requests",
      "type": "value"
    },
    "refunc": "refunc",
    "postStreamFactory": {
      "require": "./lib/stream/post-stream-factory",
      "type": "value"
    },
    "postStreamFunctions": {
      "require": "./lib/stream/post-stream-functions",
      "type": "value"
    },
    "streamFactory": {
      "require": "./lib/stream/stream-factory",
      "type": "value"
    },
    "streamFunctions": {
      "require": "./lib/stream/stream-functions",
      "type": "value"
    },
    "StreamListener": {
      "require": "./web/stream-listener",
      "type": "value"
    },
    "subscriptionRequests": {
      "require": "./lib/subscription-requests",
      "type": "value"
    },
    "subscriptionStreams": {
      "require": "./lib/subscription-streams",
      "type": "value"
    }
  }
}
